module.exports = __webpack_public_path__ + "assets/6c144079738519c937c11a405726675f.png";